import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { SimpleSelectField } from '@unite-us/app-components';
import classNames from 'classnames';

const ReferralOONCaseFields = ({
  activeUsersInGroup,
  hidden,
  field,
}) => {
  const classes = classNames({
    'referral-oon-case-fields': true,
    hidden,
  });

  const error = !hidden && isEmpty(field.value) ? 'Required' : undefined;

  return (
    <div className={classes}>
      <div className="row">
        <div className="col-xs-6">
          <SimpleSelectField
            id="primary-worker"
            label="Primary Worker"
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            optionSettings={{ labelKey: 'full_name', valueKey: 'id' }}
            options={activeUsersInGroup}
            placeholder="Choose one..."
            searchable
            error={field.touched ? error : undefined}
            required
          />
        </div>
      </div>
    </div>
  );
};

ReferralOONCaseFields.propTypes = {
  activeUsersInGroup: PropTypes.array,
  field: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    touched: PropTypes.bool,
  }).isRequired,
  hidden: PropTypes.bool,
};

ReferralOONCaseFields.defaultProps = {
  activeUsersInGroup: [],
  hidden: false,
};

export default ReferralOONCaseFields;
